import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "page-not-found-view flex-centered col-12 py-4",
  style: {"min-height":"75vh"}
}
const _hoisted_2 = { class: "col-12 d-flex" }
const _hoisted_3 = { class: "d-flex col-12 align-items-center justify-content-center flex-column mt-4 mt-sm-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-uppercase py-4 text-center" }, [
  /*#__PURE__*/_createTextVNode(" 404"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "Page not found")
], -1)

import { useHead } from "@unhead/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageNotFoundView',
  setup(__props) {

useHead({
  title: "Page Not Found",
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: {name: 'Dashboard'},
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Return ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})